module.exports = __webpack_public_path__ + "static/media/postcard3.47966b20.jpg";